module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture21-878ee5277438d9eda4e373fea2339ab8.jpg";